import React from 'react';
import { trans, getResourcePath } from '@spotahome/soyuz/client';

import TestimonialQuote from '@components/TestimonialQuote';

import './LandlordQuoteSection.scss';

const image = {
  src: getResourcePath(`/images/landlord/macarena-landlady.jpg`),
  alt: trans('landlord.landing.standard.hero.quote')
};

const LandlordQuoteSection = () => (
  <section className="landlord-quote-section">
    <TestimonialQuote
      theme="purple"
      image={image}
      message={trans('landlord.landing.standard.hero.quote')}
      source={trans('landlord.landing.standard.hero.quote.source')}
    />
  </section>
);

export default LandlordQuoteSection;
